import { NgModule } from '@angular/core';
import { HubChipComponent } from './hub-chip.component';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
    imports: [
        CommonModule,
        MatChipsModule
     ],
    declarations: [ HubChipComponent ],
    exports: [ HubChipComponent ],
})
export class HubChipModule {}
